import AuthAPI from '@/apis/business/account/auth-api.js'

export default {
  namespaced: true,
  state: {
    /**
     * Thông tin đăng nhập giáo viên
     */
    account: {
      UserName: '',
      Password: '',
      PhoneNumber: '',
      Email: '',
      IsAppAuthen: false,
      Remember: false,
      Code: '',
      DeviceInfo: '',
      Context: '', // "register", "forgotpassword", "twoFactorAuthen", "confirmAccount"
      SendMethod: '', // Phương thức bên thứ 3 gửi mã OTP đi, App, Email, PhoneNumber
      MethodSendCode: 'UserName', // 'UserName', 'PhoneNumber', 'Email' Thông tin userName truyền lên server khi bấm xác thực 2 bước
      CaptchaId: '',
      CaptChaValue: '',
      IsShowCaptcha: false
    },
    /**
     * Các phương thức nhận mã OTP được sử dụng
     */
    AppUse: {
      GoogleAuth: false,
      Email: false,
      Phone: false
    },
    /**
     * Thông tin quên mật khẩu
     */
    forgotPasswordEntity: {
      UserName: '',
      SendMethod: '',
      PhoneNumber: '',
      Email: '',
      Code: '',
      Context: '',
      Token: '',
      UserId: '',
      password: '',
      confirmPassword: ''
    },
    /**
     * Thông tin đăng ký giáo viên
     */
    registerEntity: {
      LocationID: '',
      OrganizationID: '',
      FirstName: '  ',
      LastName: '',
      Email: '',
      PhoneNumber: '',
      Password: '',
      Code: '',
      Context: '',
      SendMethod: '' // phương thức mà bên thứ 3 gửi mã OTP về cho đki PhoneNumber ,Email
    },
    /**
     * Thông tin giáo viên chọn đơn vị công tác
     */
    updateOrganizationEntity: {
      OrganizationID: '',
      SessionID: '',
      UserId: ''
    }

  },
  getters: {},
  mutations: {
    setEntityUpdateOrganization (state, entity) {
      state.updateOrganizationEntity = entity
    },

    setEntityRegister (state, entity) {
      state.registerEntity = entity
    },

    setEntityForgotPassword (state, entity) {
      state.forgotPassword = entity
    },

    setAccount (state, entity) {
      state.account = entity
    }
  },
  actions: {
    /**
     * @description Đăng nhập giáo viên
     * @param {*} context
     * @param {*} params
     * @returns
     */
    login (context, params) {
      return AuthAPI.postAsync('login', params)
    },

    /**
     * @description Lấy các phương thức nhận mã OTP
     * @param {*} context
     * @param {*} params
     * @returns
     */
    tryAnotherWay (context, params) {
      return AuthAPI.postAsync('anotherway', params)
    },

    /**
     * @description Gửi lại mã OTP
     * @param {*} context
     * @param {*} params
     * @returns
     */
    sendAgainOTP (context, params) {
      return AuthAPI.postAsync('sendAgainOTP', params)
    },

    /**
     * @description Xác thực 2 lớp
     * @param {*} context
     * @param {*} params
     * @returns
     */
    twoFactorConfirm (context, params) {
      return AuthAPI.postAsync('twofactor/confirm', params)
    },

    /**
     * @description Lấy DeviceId
     * @param {*} context
     * @returns
     */
    getDeviceId (context) {
      return AuthAPI.getAsync('deviceid')
    },

    /** build url gọi sang zalo */
    getUrlPermissionZalo (context) {
      return AuthAPI.getAsync('login-zalo/url-permission')
    },
    /** lấy accesstoken bên zalo để sử dụng cho các bước tiếp
     * code lấy từ param khi zalo redirect về
     */
    getTokenProvider (context, code) {
      return AuthAPI.getAsync('login-zalo/token-provider?code=' + code)
    },
    /** params gồm deviceInfo, và tokenProvider  */
    loginZalo (context, params) {
      return AuthAPI.postAsync('login-zalo', params)
    },
    /** params gồm userName, và tokenProvider  */
    getOTPZalo (context, params) {
      return AuthAPI.postAsync('login-zalo/otp', params)
    },
    /** params gồm OTPCodeType, userName, code, deviceInfo và tokenProvider  */
    confirmOTPZalo (context, params) {
      return AuthAPI.postAsync('login-zalo/otp/confirm', params)
    },

    /**
     * @description Quên mật khẩu
     * @param {*} context
     * @param {*} params
     * @returns
     */
    forgotPassword (context, params) {
      return AuthAPI.postAsync('password/forgot', params)
    },

    /**
     * @description xác nhận otp
     * @param {*} context
     * @param {*} params
     * @returns
     */
    confirmPassword (context, params) {
      return AuthAPI.postAsync('password/confirm', params)
    },

    /**
     * @description Xác nhận mật khẩu mới
     * @param {*} context
     * @param {*} params
     * @returns
     */
    resetPassword (context, params) {
      return AuthAPI.postAsync('password/reset', params)
    },

    /**
     * @description Sinh mã captcha
     * @param {*} context
     * @param {*} params
     * @returns
     */
    genCaptcha (context, params) {
      return AuthAPI.getAsync('captcha', params)
    },

    /**
     * @description Đăng ký tài khoản
     * @param {*} context
     * @param {*} params
     * @returns
     */
    register (context, params) {
      return AuthAPI.postAsync('register', params)
    },

    /**
     * @description Xác nhận mã OTP khi đăng ký tài khoản
     * @param {*} context
     * @param {*} params
     * @returns
     */
    confirmRegister (context, params) {
      return AuthAPI.postAsync('register/confirm', params)
    },

    /**
     * @description Thử cách xác nhận OTP khác khi đăng ký
     * @param {*} context
     * @param {*} params
     * @returns
     */
    anotherwayRegister (context, params) {
      return AuthAPI.postAsync('register/anotherway', params)
    },

    /**
     * @description Cập nhật đơn vị công tác
     * @param {*} context
     * @param {*} params
     * @returns
     */
    updateOrganization (context, params) {
      return AuthAPI.postAsync('login/organization', params)
    },

    /**
     * @author PVThang
     * @description Kích hoạt tài khoản giáo viên
     * @param {*} context
     * @param {*} params
     * @returns Kết quả trả về từ server
     */
    active (context, params) {
      return AuthAPI.postAsync('active', params)
    },
    /**
     * Lưu thông tin người dùng lên Ao cơ hội
     * @param {*} context
     * @param {*} params
     * @returns
     */
    saveInfoTeacherCRM (context, params) {
      return AuthAPI.postAsync('insert-classroom-exercises', params)
    }
  }
}
